// Libraries
import { MouseEventHandler } from 'react';

// Styles
import styles from './Button.module.css';

/**
 * @function Button
 * Describe the component's function
 *
 * @example
 * return (
 *   <Button text='' onClick={() => false} />
 * )
 */
function Button({
    text,
    style = 'default',
    disabled = false,
    onClick = () => false,
}: ButtonProps): JSX.Element {
    const className = `${styles.button}${
        style !== 'default' ? ` ${styles[style]}` : ''
    }`;

    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </button>
    );
}

/**
 * @interface ButtonProps
 * Describes the properties required for the Button component
 *
 * @property {string} text
 * @property {string} style
 * @property {boolean} disabled
 * @property {MouseEventHandler} onClick
 */
export interface ButtonProps {
    text: string;
    style?: string;
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
}

// Exports
export default Button;
